import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Input } from 'semantic-ui-react';
import ReadCookie from '../../../functions/readcookies';
import Add from './add';

class Title extends React.Component {

  state = {
    maxWidth: 'lg', fullWidth: true, maxWidthedit: 'sm'
  }

  edit() {
    let context = this;
    let id = this.state.editId; let dnp = this.state.editDnp;
    let stock = this.state.editStock; let oldData = this.props.data;
    let partno = this.state.partno; let brand_id = this.state.brand_id;
    let oldstock = this.state.oldstock; let edittax = this.state.edittax;
    let datas = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < datas.length; i++) { branchId = datas[i].branch_id; }
    if (edittax < 10) { edittax = '1.0'+edittax; }
    else { edittax = '1.'+edittax; }
    let dnprate = Number(dnp/edittax).toFixed(2);
    let data1 = { 'id': id, 'dnp': dnp, 'stock': stock, 'oldstock': oldstock, 'partno': partno,
                  'brand_id': brand_id, 'branchId': branchId, 'edittax': edittax , 'dnprate': dnprate};
    this.setState({ load: true, message: 'Editing Purchase Details!!!!' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchasedetail/editpurchasedetails.php',
      success: function(data)
      {
        context.setState({ load: false });
        if (data == 1) {
          context.setState({ edit: false });
          for (var i = 0; i < oldData.length; i++) {
            if (oldData[i].id == context.state.editId) {
              oldData[i].dnp = dnp;
              oldData[i].stock = stock;
            }
          }
          context.props.update(oldData);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  delete() {
    let context = this;
    let id = this.state.deleteId;
    this.setState({ load: true, message: 'Deleting Purchase Details!!!!' });
    let datas = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < datas.length; i++) { branchId = datas[i].branch_id; }
    let data1 = { 'id': id, 'branch': branchId };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchasedetail/deletepurchaseorderdetail.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false });
        if (data == 1) {
          context.setState({ delete: false });
          context.props.getorders(context.props.viewId, 'Yes');
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getPurchaseDetail() {
    let context = this;
    context.props.getPurchaseDetails(1, context.props.orderElement, context.props.sortingOrder, context.props.from_date, context.props.to_date);
  }

  onChangeHandle = (type) => (f, { value }) => {
    if (type == 'editdnp') {
      let tax = this.state.edittax;
      let dnp = value;
      dnp = dnp - ((dnp * tax)/100);
      this.setState({ originaldnp: dnp })
    }
    if (value <= 0) {
      alert('Enter the correct details');
      return;
    }
    this.setState({ [type] : value })
  }

  handleClose() { this.setState({ edit: false, delete: false, deleteAll: false }) }

  deleteAll(id) { this.props.delete(id); this.setState({ deleteAll: false }) }

  editItems() {
    this.setState({ addDialog: true });
  }

  handleCloseDialog() {
    this.setState({ addDialog: false });
  }

  render() {
    return (
      <div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.props.viewOpen}
            onClose={this.props.handleClose}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Order Details</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <table width="100%" id='table'>
                  <tr>
                    <th id='tableheader'><center>Sino</center></th>
                    <th id='tableheader'><center>Part Name</center></th>
                    <th id='tableheader'><center>Brand</center></th>
                    <th id='tableheader'><center>Part Code</center></th>
                    <th id='tableheader'><center>Stocks</center></th>
                    <th id='tableheader'><center>DNP</center></th>
                    <th id='tableheader'><center>Total</center></th>
                    {/* <th id='tableheader'>
                      <center>Edit</center>
                    </th>
                    <th id='tableheader'>
                      <center>Delete</center>
                    </th> */}
                  </tr>
                  { this.props.data.map((z) => {
                      let partname = z.partname; let partno = z.partno;
                      let brandname = z.brandname; let partcode = z.partcode;
                      let stock = z.stock; let tax = z.tax;
                      let value = ((z.dnp * z.stock) + (((z.dnp * z.stock) * tax)/100)).toFixed(2);
                      if (partname == null || partname == undefined || partname == '') {
                        partname = 'Other Charge';
                        partno = 0; brandname = '-';
                        partcode = '-'; stock = '-';
                      }
                      return (
                        <tr id='tbody'>
                          <td><center>{z.sino}</center></td>
                          <td>{partno+'->'+partname}</td>
                          <td><center>{brandname}</center></td>
                          <td><center>{partcode}</center></td>
                          <td><center>{stock}</center></td>
                          <td><center>{z.dnp}</center></td>
                          <td><center>{((z.dnp * z.stock) + (((z.dnp * z.stock) * tax)/100)).toFixed(2)}</center></td>
                          {/* <td style={{cursor: 'pointer'}}
                              onClick={ () => {
                                this.setState({ edit: true, editId: z.id, editStock: z.stock,
                                  editDnp: value, brandname: brandname, oldstock: z.stock,
                                  partno: z.partno, brand_id: z.brand_id, edittax: z.tax,
                                  originaldnp: z.dnp,
                                }) }}>
                            <center>Edit</center>
                          </td>
                          <td style={{cursor: 'pointer'}}
                              onClick={ () => { this.setState({ delete: true, deleteId: z.id })}}>
                            <center>Delete</center>
                          </td> */}
                        </tr>
                      );
                    })
                  }
                </table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Add branch={this.props.branch} fromtype={'alter'} viewId={this.props.viewId}
                state={this.props.state} getorders={this.props.getorders}/>
              <Buttons color="primary" onClick={ () => { this.props.download(this.props.viewId) }}>Download Excel</Buttons>
              <Buttons color="primary" onClick={ () => { this.props.downloadPdf(this.props.viewId) }}>Download PDF</Buttons>
              <Buttons color="primary" onClick={ () => { this.props.handleClose() }}>Close</Buttons>
          </DialogActions>
          </Dialog>
        </React.Fragment>

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidthedit}  open={this.state.edit}
            onClose={this.handleClose.bind(this)}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Edit Order Details</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Grid>
                  <Grid.Column mobile={8} tablet={8} computer={8}>
                    { this.state.brandname == '-' ?
                      (
                        <div>
                          <b>Stock</b><br/>
                          <Input fluid value={this.state.editStock} disabled onChange={this.onChangeHandle('editStock')} />
                        </div>
                      ) :
                      (
                        <div>
                          <b>Stock</b><br/>
                          <Input fluid value={this.state.editStock} onChange={this.onChangeHandle('editStock')} />
                        </div>
                      )
                    }
                  </Grid.Column>
                  <Grid.Column mobile={8} tablet={8} computer={8}>
                    <b>DNP</b><br/>
                    <Input disabled fluid value={this.state.editDnp} onChange={this.onChangeHandle('editDnp')} />
                  </Grid.Column>
                  <Grid.Column mobile={8} tablet={8} computer={8}>
                    <Buttons fullWidth variant="outlined" color="primary" onClick={ () => { this.setState({ edit: false }) }}>Cancel</Buttons>
                  </Grid.Column>
                  <Grid.Column mobile={8} tablet={8} computer={8}>
                    <Buttons fullWidth variant="outlined" color="primary" onClick={this.edit.bind(this)}>Submit</Buttons>
                  </Grid.Column>
                </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>


            <Dialog fullWidth={this.state.fullWidth}
              maxWidth={this.state.maxWidthedit}  open={this.state.delete}
              onClose={this.handleClose.bind(this)}
              aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">Delete Order Details</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Grid>
                    <Grid.Column mobile={8} tablet={8} computer={16}>Do you want to remove it</Grid.Column>
                    <Grid.Column mobile={8} tablet={8} computer={8}>
                      <Buttons fullWidth variant="outlined" color="primary" onClick={ () => { this.setState({ delete: false }) }}>Cancel</Buttons>
                    </Grid.Column>
                    <Grid.Column mobile={8} tablet={8} computer={8}>
                      <Buttons fullWidth variant="outlined" color="primary" onClick={this.delete.bind(this)}>Submit</Buttons>
                    </Grid.Column>
                  </Grid>
                </DialogContentText>
              </DialogContent>
            </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Title;
